export default __webpack_public_path__ + "static/media/mana1.7a614512.svg";